import axios from "axios";

let instance = axios.create({
  baseURL: process.env.REACT_APP_B2C_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;



// WEBPACK FOOTER //
// src/services/axiosB2C.js